var _defs, _rect, _path, _g, _path2, _path3, _circle, _path4, _g2, _path5, _circle2, _path6, _path7, _path8, _path9, _rect2, _g3, _g4, _rect3, _path10, _g5, _path11, _path12, _path13, _path14, _rect4, _g6, _g7, _g8, _rect5, _g9, _path15, _g10, _g11, _path16, _g12, _rect6, _g13, _rect7, _path17, _path18, _rect8, _rect9, _path19, _path20, _g14, _g15, _path21, _g16, _rect10, _path22, _rect11, _rect12, _path23, _path24, _g17, _path25, _path26, _g18, _g19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCastToTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st6 {\n        font-family: Roboto-Bold, Roboto;\n        font-size: 74.5px;\n        font-weight: 700;\n      }\n\n      .st6, .st7 {\n        isolation: isolate;\n      }\n\n      .st6, .st8 {\n        fill: #fff;\n      }\n\n      .st9 {\n        fill: url(#linear-gradient);\n      }\n\n      .st10 {\n        fill: #ffb000;\n      }\n\n      .st11 {\n        fill: #ea6a00;\n      }\n\n      .st12 {\n        fill: #ff7900;\n      }\n\n      .st13 {\n        fill: #ce5d00;\n      }\n\n      .st14 {\n        opacity: .2;\n      }\n\n      .st15 {\n        fill: #ff7f00;\n      }\n\n      .st16 {\n        fill: #ff8500;\n      }\n\n      .st17 {\n        fill: none;\n        stroke: #ffb000;\n        stroke-miterlimit: 10;\n        stroke-width: 20px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -268.5,
    y1: 1553.1,
    x2: -39.1,
    y2: 1842.2,
    gradientTransform: "translate(0 509.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -317,
    y1: 1510.6,
    x2: 2.2,
    y2: 1510.6,
    gradientTransform: "translate(0 509.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -1734.1,
    y1: 1168,
    x2: -1733.9,
    y2: 1167.8,
    gradientTransform: "translate(0 509.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 388.7,
    y1: 106.7,
    x2: 389,
    y2: 106.5,
    gradientTransform: "translate(0 509.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: -1296.5,
    y1: 68.2,
    x2: -1027.2,
    y2: 586,
    gradientTransform: "translate(0 -840.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: -1296.5,
    y1: 732.3,
    x2: -1027.2,
    y2: 1250.1,
    gradientTransform: "translate(0 -840.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e35500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: -496.8,
    y1: 1321.9,
    x2: -227.5,
    y2: 1839.7,
    xlinkHref: "#linear-gradient5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: -2036.2,
    y: 858.8,
    width: 512,
    height: 512,
    rx: -506.1,
    ry: -506.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M750.7-696.1l97.8,126.1v180.6c0,36.5-29.6,66-66,66h-242.3l-106.9-145.7,306.3-4.2,11.1-222.8h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M51.4-1321.1h-417.7c-8.3,0-15,6.7-15,15v245.3c0,8.3,6.7,15,15,15H51.4c8.3,0,15-6.7,15-15v-245.3c0-8.3-6.7-15-15-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-12.8-1015.9h-289.2c-8.3,0-15,6.7-15,15s6.7,15,15,15H-12.8c8.3,0,15-6.7,15-15s-6.7-15-15-15Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-61-889.3c-8.3,0-15,6.7-15,15s6.7,15,15,15c22.7,0,41.2,18.5,41.2,41.2s6.7,15,15,15,15-6.7,15-15c0-39.3-32-71.2-71.2-71.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-61-945.5c-8.3,0-15,6.7-15,15s6.7,15,15,15c53.7,0,97.5,43.7,97.5,97.5s6.7,15,15,15,15-6.7,15-15c0-70.3-57.2-127.5-127.5-127.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -61,
    cy: -818.1,
    r: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M720.9-838.9h-207.2l-1-15h208.2c18,0,32.6-14.6,32.6-32.6v-198.7c0-18-14.6-32.6-32.6-32.6h-276.7c-18,0-32.6,14.6-32.6,32.6v131.4l-15-1.6v-129.9c0-26.3,21.4-47.6,47.6-47.6h276.7c26.3,0,47.6,21.4,47.6,47.6v198.8c0,26.3-21.4,47.6-47.6,47.6Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-2049.5,130.1h0c0-3.3-.2-6.5-.4-9.6-.2-2.9-.5-5.6-.9-8.4-8-58.7-54.6-105.3-113.3-113.3-2.8-.4-5.6-.7-8.4-.9-3.2-.3-6.5-.3-9.7-.3h-3.3v116.9c0,10.3,8.5,18.7,18.9,18.9h116.9v-3.3h.2ZM-2075.2,112c.3,1.9.6,4,.8,5.9h-24.3c-5.4-36.7-34.5-65.9-71.3-71.3v-24.3c1.9.2,3.9.5,5.8.8,45.4,7.6,81.3,43.5,88.9,88.9h0ZM-2170.2,71c23.4,4.8,42,23.3,46.8,46.8h-25c-3.6-10.1-11.6-18.1-21.7-21.8v-25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1822.1,111.4c0,12.2-10,22.1-22.1,22.1,0,0-194.8-.1-194.8-.2h0c0-4.2,0-8.2-.4-12.3,0-1-.2-2-.2-3s-.2-1.7-.2-2.5h195.8c2.4.1,4.3-1.9,4.3-4.2V-110.4c0-2.4-2-4.3-4.3-4.3h-319.5c-2.4,0-4.3,2-4.3,4.3l.6,100.2c-.8,0-1.5-.2-2.3-.2-1.1-.2-2.2-.3-3.2-.3-4.1-.3-8.2-.4-12.3-.4h0l-.6-99.2c0-12.2,10-22.1,22.1-22.1h319.4c12.2,0,22.1,10,22.1,22.1V111.4h-.1c0,.1,0,0,0,0h0Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1196.5,650.9v2.7h0v-2.7Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 159.9,
    cy: -798.9,
    r: 7.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1734.1-658.5v.4-.4h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1680.3-826.5v163.3c0,6.4-5.1,11.5-11.5,11.5h-79.2c-6.3,0-11.5-5.1-11.5-11.5v-163.3c0-6.4,5.1-11.5,11.5-11.5h81c5.5.8,9.7,5.6,9.7,11.4h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-1740.6-661.4h17.5c1.7,0,3.1,1.4,3.1,3.1h0c0,1.7-1.4,3.1-3.1,3.1h-17.5c-1.7,0-3.1-1.4-3.1-3.1h0c0-1.7,1.4-3.1,3.1-3.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-964.1-1329.9v59.8h-87.2c-8.5,0-15.3,6.5-15.3,14.5v162.2h-241c-2.1,0-3.9-1.8-3.9-3.9v-84.7c.6,0,1.1,0,1.7-.2,77.9-10.6,139.6-72.3,150.2-150.2,0-.5.1-1,.2-1.5h191.4c2.1,0,3.9,1.8,3.9,3.9h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: -1785.9,
    y: -828,
    width: 84.3,
    height: 158.7
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1707.2-675.2h7.9c2.4,0,4.3-1.9,4.3-4.3v-7.9c-6.8,0-12.2,5.5-12.2,12.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1723.5-675.2h8.2c0-11.3,9.1-20.4,20.4-20.4v-8.2c-15.8,0-28.6,12.8-28.6,28.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1694.9-720.1v8.2h-4.1c-17,1.9-30.5,15.4-32.4,32.4v.8c0,1.1-.1,2.2-.1,3.3h-8.2c0-1.1,0-2.2.1-3.3v-.8c1.9-21.5,19.1-38.7,40.6-40.6h4.1Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: -2069.5,
    y: 140.4,
    width: 66.7,
    height: 18.4,
    transform: "translate(-562.6 -1263.6) rotate(-39.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: -1992,
    y: 115.9,
    width: 18.4,
    height: 66.7,
    transform: "translate(-833.9 -1473.7) rotate(-50.4)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 0,
    width: 512,
    height: 512,
    rx: 66.9,
    ry: 66.9
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M428.9,110.8l83.1,114.3v218.1c0,38.1-30.9,68.8-68.8,68.8H171.8l-97.6-145.9,358.5,4,9-239-12.8-20.3Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M230.6,112.7v-3.8H94.3c-12.1.2-21.9,10-22,22v136.3h3.8c3.8,0,7.6,0,11.4-.3,3.3-.2,6.5-.6,9.8-1,68.5-9.3,122.8-63.7,132.2-132.2.4-3.3.8-6.4,1-9.8.2-3.7.4-7.4.4-11.2h-.2ZM200.8,133.7c-8.9,53-50.7,94.8-103.7,103.7-2.2.3-4.5.7-6.7.9v-28.3c42.9-6.3,76.8-40.3,83.1-83.1h28.3c-.2,2.2-.6,4.6-.9,6.9h-.1ZM90.2,181.5v-29.1c11.8-4.3,21.1-13.6,25.3-25.4h29.1c-5.6,27.3-27.2,48.9-54.6,54.6h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M441.8,131.2v225.4c0,12.4-10.1,22.5-22.5,22.5H94.6c-12.4,0-22.5-10.1-22.5-22.5v-76.7h0c4.2,0,8.3-.1,12.5-.4,1,0,2.1-.1,3.3-.3.8,0,1.6-.1,2.4-.2v77.7c0,2.4,1.9,4.4,4.4,4.4h324.7c2.4,0,4.4-1.9,4.4-4.4v-225.4c0-2.4-1.9-4.4-4.4-4.4h-177c0-.9.2-1.7.2-2.6s.2-2,.2-3c.3-4.2.4-8.2.4-12.5h0c0-.1,176-.1,176-.1,12.4,0,22.5,10.1,22.5,22.5h.1Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M235.1,85.1v3h0v-3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.7,402.6v.4-.4h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M449.2,213.7v183.7c0,7.2-5.7,12.9-12.9,12.9h-89.1c-7.1,0-12.9-5.7-12.9-12.9v-183.7c0-7.2,5.7-12.9,12.9-12.9h91.1c6.2.9,10.9,6.3,10.9,12.8h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M381.4,399.4h19.7c1.9,0,3.5,1.6,3.5,3.5h0c0,1.9-1.6,3.5-3.5,3.5h-19.7c-1.9,0-3.5-1.6-3.5-3.5h0c0-1.9,1.6-3.5,3.5-3.5Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 344.8,
    y: 212,
    width: 94.8,
    height: 178.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M419,383.9h8.9c2.7,0,4.8-2.1,4.8-4.8v-8.9c-7.6,0-13.7,6.2-13.7,13.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M400.7,383.9h9.2c0-12.7,10.2-22.9,22.9-22.9v-9.2c-17.8,0-32.2,14.4-32.2,32.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M432.8,333.4v9.2h0c-1.2,0-2.5,0-3.7.1h-.9c-19.1,2.1-34.3,17.3-36.4,36.4v4.6h-9.2v-4.6c2.1-24.2,21.5-43.5,45.7-45.7h.9c1.2,0,2.5-.1,3.7-.1h0Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 189.8,
    y: 382.7,
    width: 75,
    height: 20.7,
    transform: "translate(-198.4 235.1) rotate(-39.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 276.7,
    y: 355,
    width: 20.7,
    height: 75,
    transform: "translate(-198.4 363.5) rotate(-50.4)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_01-Play"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1971.9-4.8l-44.4-25.7c-1.3-.8-2.7-1.2-4.2-1.2-4.8,0-8.7,3.9-8.7,8.7h0v55.1c0,4.8,3.9,8.6,8.6,8.6s3.2-.5,4.6-1.3l44.5-28.1c4.4-2.8,5.8-8.6,3-13-.8-1.3-2-2.4-3.3-3.2h0,0Z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: -1416.1,
    y: -765.7,
    width: 512,
    height: 512,
    rx: -196,
    ry: -196
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1205.8-357.2h0c0-3.3-.2-6.5-.4-9.6-.2-2.9-.5-5.6-.9-8.4-8-58.7-54.6-105.3-113.3-113.3-2.8-.4-5.6-.7-8.4-.9-3.2-.3-6.5-.3-9.7-.3h-3.3v116.9c0,10.3,8.5,18.7,18.9,18.9h116.9v-3.3h.2,0ZM-1231.5-375.3c.3,1.9.6,4,.8,5.9h-24.3c-5.4-36.7-34.5-65.9-71.3-71.3v-24.3c1.9.2,3.9.5,5.8.8,45.4,7.6,81.3,43.5,88.9,88.9h0ZM-1326.5-416.3c23.4,4.8,42,23.3,46.8,46.8h-25c-3.6-10.1-11.6-18.1-21.7-21.8v-25h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-978.4-375.9c0,12.2-10,22.1-22.1,22.1,0,0-194.8-.1-194.8-.2h0c0-4.2-.1-8.2-.4-12.3,0-1-.2-2-.2-3s-.2-1.7-.2-2.5h195.8c2.4.1,4.3-1.9,4.3-4.2v-221.7c0-2.4-2-4.3-4.3-4.3h-319.5c-2.4,0-4.3,2-4.3,4.3l.6,100.2c-.8-.1-1.5-.2-2.3-.2-1.1-.2-2.2-.3-3.2-.3-4.1-.3-8.2-.4-12.3-.4h0l-.6-99.2c0-12.2,10-22.1,22.1-22.1h319.4c12.2,0,22.1,10,22.1,22.1v221.7h-.1c0,.1,0,0,0,0h0Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1182.9-657v2.7h0v-2.7Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: -1225.8,
    y: -346.9,
    width: 66.7,
    height: 18.4,
    transform: "translate(-58.4 -837.6) rotate(-39.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: -1148.3,
    y: -371.3,
    width: 18.4,
    height: 66.7,
    transform: "translate(-152.6 -1000.2) rotate(-50.4)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_01-Play1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1128.2-492.1l-44.4-25.7c-1.3-.8-2.7-1.2-4.2-1.2-4.8,0-8.7,3.9-8.7,8.7h0v55.1c0,4.8,3.9,8.6,8.6,8.6s3.2-.5,4.6-1.3l44.5-28.1c4.4-2.8,5.8-8.6,3-13-.8-1.3-2-2.4-3.3-3.2h-.1Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1169.7-765.7h198.7c36.9,0,66.9,30,66.9,66.9v40h-219.4c-25.5,0-46.2-20.7-46.2-46.2v-60.7h0Z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(-1140.3 -681.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2025"))))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: -2697.6,
    y: 90,
    width: 512,
    height: 512,
    rx: -836.8,
    ry: -836.8
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1947,523.2c0-4.1-3.1-7.2-7.2-7h0c-4.1.2-7.4,3.7-7.5,7.8-.5,22.8-18.2,42.6-40.8,45.5h0c-4.1.5-7.1,4.3-6.9,8.3.3,4,3.7,6.9,7.8,6.4,14.6-1.9,28.3-9.2,38.4-20.5,10.1-11.3,15.9-25.7,16.1-40.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1916.4,520.7c-.2-4.1-3.6-7-7.7-6.5s-7.2,4.1-7,8.2c-.9,38.8-31.1,72.5-69.6,77.7-3.7.7-6.4,4.1-6.4,7.8s3.3,7.2,7.4,6.9c46.1-6.1,82.3-46.5,83.3-93v-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1977.5,524.5c0-4.1-3.2-7.2-7.2-7-4.1.2-7.4,3.7-7.5,7.8-.3,6.7-5.5,12.6-12.2,13.6-3.9.6-6.8,4.1-6.7,8,0,4.1,3.5,7.1,7.5,6.7,7-.9,13.5-4.4,18.3-9.8,4.8-5.4,7.6-12.3,7.7-19.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-2005,526h0c2.8-3.1,2.7-7.8-.2-10.4-2.9-2.6-7.6-2.2-10.4.9s-2.7,7.8.2,10.4c2.9,2.6,7.6,2.2,10.4-.9h0Z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -1416.1,
    y: -101.6,
    width: 512,
    height: 512,
    rx: -196,
    ry: -196
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1169.5,27.6v2.4h0v-2.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-980.4,43.7v209.1c0,8.3-6.7,15-14.9,15h-149.4v2.3h-29.9v-2.3h-149.4c-8.3,0-14.9-6.7-14.9-15V43.7c0-8.3,6.7-14.9,14.9-14.9h328.6c8.3,0,14.9,6.7,14.9,14.9h0Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: -1334.8,
    y: 30,
    width: 347.6,
    height: 230.3,
    rx: -319.9,
    ry: -319.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: -1065,
    y: 105.9,
    width: 104.8,
    height: 187.9,
    rx: -427.7,
    ry: -427.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1066,164.3c-2.4,0-4.5-2-4.5-4.5v-42.3c0-8.6,7-15.5,15.5-15.5h84.4c8.6,0,15.5,7,15.5,15.5v164.5h0c0,8.6-7,15.5-15.5,15.5h-84.4c-8.6,0-15.5-7-15.5-15.5v-42.3c0-2.4,2-4.5,4.5-4.5s4.5,2,4.5,4.5v42.3h0c0,3.7,3,6.6,6.6,6.6h84.4c3.7,0,6.6-3,6.6-6.6V117.5c0-3.7-3-6.6-6.6-6.6h-15.5v1.4c0,6.9-4.9,14.2-12.4,14.2h-28.6c-6.8,0-12.4-6.4-12.4-14.2v-1.3h-15.5c-3.7,0-6.6,3-6.6,6.6v42.3c0,2.4-2,4.5-4.5,4.5h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-994.9,271h-35.5c-2.4,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h35.5c2.4,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5Z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1089.8,196.4c-1.8,1.6-1.9,4.5-.3,6.3h0c1.7,1.8,4.5,1.9,6.3.3,10.1-9.2,25.5-9.2,35.5,0h0c1.8,1.6,4.7,1.5,6.3-.3s1.5-4.6-.3-6.3c-6.5-6-15-9.3-23.9-9.3s-17.3,3.3-23.8,9.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1102.8,183.1c-1.7,1.8-1.6,4.6.2,6.3s4.6,1.6,6.3-.2c17.1-15.7,43.5-15.7,60.7,0,1.7,1.4,4.2,1.3,5.8-.3,1.8-1.7,1.8-4.5.2-6.3-20.6-18.8-52.1-18.8-72.7,0-.2,0-.3.3-.4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1077.4,209.9c-1.8,1.7-1.9,4.5-.2,6.3s4.5,1.9,6.3.3c3.1-2.7,7.6-2.7,10.6,0,1.8,1.5,4.4,1.4,6.1-.3s1.7-4.6,0-6.3c-3.1-2.9-7.2-4.5-11.4-4.5s-8.3,1.6-11.4,4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1066.1,222.1h0c-2.4,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5,4.5-2,4.5-4.5-2-4.5-4.5-4.5h0Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_01-Play3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1138.9,142.1l-35.3-20.4c-1.1-.6-2.2-1-3.3-1-3.8,0-6.9,3.1-6.9,6.9h0v43.8c0,3.8,3.1,6.8,6.8,6.8s2.5-.4,3.7-1.1l35.4-22.3c3.5-2.2,4.6-6.8,2.4-10.3-.6-1.1-1.6-1.9-2.6-2.5h-.2Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-1085.1,289.5c0,4.1-3.3,7.4-7.4,7.4h-134.4c-4.1,0-7.4-3.3-7.4-7.4s3.3-7.4,7.4-7.4h52.3l.2-32.1h29.9l-.2,32.1h52.3c4.1,0,7.4,3.3,7.4,7.4h0Z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1653.5,110.7h-22.3c-6.8,0-12.1,5.4-12.1,12.1v22.3c19.2,0,34.4-15.5,34.4-34.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1607.6,110.7h-23.1c0,31.9-25.7,57.5-57.5,57.5v23.1c44.6,0,80.7-36.1,80.7-80.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1688.2,237.3v-23.1h0c3.1,0,6.2,0,9.3-.3h2.3c47.9-5.4,86-43.4,91.4-91.4v-2.3c0-3.1.3-6.2.3-9.3h23.1c0,3.1,0,6.2-.3,9.3v2.3c-5.4,60.6-53.9,109.1-114.5,114.5h-2.3c-3.1,0-6.2.3-9.3.3h0Z"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: -616.5,
    y: 487.9,
    width: 512,
    height: 512,
    rx: 66.9,
    ry: 66.9
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-180.1,636.4v208.6c0,8.2-6.7,15-14.9,15h-149.1v2.3h-29.8v-2.3h-149c-8.2,0-14.9-6.7-14.9-15v-208.6c0-8.2,6.7-14.9,14.9-14.9H-195c8.2,0,14.9,6.7,14.9,14.9h0Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: -533.7,
    y: 622.7,
    width: 346.8,
    height: 229.7,
    rx: 17.6,
    ry: 17.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: -243.4,
    y: 731.7,
    width: 86.4,
    height: 154.9,
    rx: -35.3,
    ry: -35.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-244.2,779.8c-2.1,0-3.7-1.6-3.7-3.7v-34.8c0-7.1,5.7-12.8,12.8-12.8h69.7c7.1,0,12.8,5.7,12.8,12.8v135.6h0c0,7.1-5.7,12.8-12.8,12.8h-69.7c-7.1,0-12.8-5.7-12.8-12.8v-34.8c0-2.1,1.6-3.7,3.7-3.7s3.7,1.6,3.7,3.7v34.8h0c0,3,2.4,5.5,5.5,5.5h69.7c3,0,5.5-2.4,5.5-5.5v-135.6c0-3-2.4-5.5-5.5-5.5h-12.8v1.2c0,5.7-4,11.6-10.2,11.6h-23.5c-5.6,0-10.2-5.3-10.2-11.7v-1.2h-12.8c-3,0-5.5,2.4-5.5,5.5v34.8c0,2.1-1.6,3.7-3.7,3.7h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-185.6,867.7h-29.3c-2.1,0-3.7,1.6-3.7,3.7s1.6,3.7,3.7,3.7h29.3c2.1,0,3.7-1.6,3.7-3.7s-1.6-3.7-3.7-3.7Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_01-Play2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-328.7,739.2l-39.8-23c-1.2-.7-2.4-1.1-3.8-1.1-4.3,0-7.8,3.5-7.8,7.8h0v49.3c0,4.3,3.5,7.7,7.7,7.7s2.9-.4,4.1-1.2l39.8-25.2c3.9-2.5,5.2-7.7,2.7-11.6-.7-1.2-1.8-2.1-3-2.9h0Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-284.6,881.5c0,4.1-3.3,7.4-7.4,7.4h-134.1c-4.1,0-7.4-3.3-7.4-7.4s3.3-7.4,7.4-7.4h52.2l.2-32.1h29.8l-.2,32.1h52.2c4.1,0,7.4,3.3,7.4,7.4h0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-369.8,617.1v2.4h0v-2.4Z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-495.1,636.6h-15.8c-4.8,0-8.6,3.8-8.6,8.6v15.8c13.6,0,24.4-11,24.4-24.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-462.5,636.6h-16.4c0,22.6-18.2,40.7-40.7,40.7v16.4c31.6,0,57.1-25.6,57.1-57.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-519.6,726.3v-16.4h0c2.2,0,4.4,0,6.6-.2h1.6c33.9-3.8,61-30.8,64.7-64.7v-1.6c0-2.2.2-4.4.2-6.6h16.4c0,2.2,0,4.4-.2,6.6v1.6c-3.8,43-38.1,77.4-81.1,81.1h-1.6c-2.2,0-4.4.2-6.6.2h0Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-252.9,825.2l6.1,6.1c1.9,1.9,4.7,1.9,6.6,0l6.1-6.1c-5.2-5.2-13.6-5.2-18.7,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-265.4,812.7l6.3,6.3c8.7-8.7,22.7-8.7,31.3,0l6.3-6.3c-12.2-12.2-31.8-12.2-44,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-208.9,800.1l-6.3,6.3h0c-.8-.8-1.7-1.7-2.6-2.4l-.6-.6c-14.5-11.6-35.3-11.6-49.8,0l-.6.6c-.8.8-1.8,1.6-2.6,2.4l-6.3-6.3c.8-.8,1.7-1.7,2.6-2.4l.6-.6c18-15,44.4-15,62.4,0l.6.6c.8.8,1.8,1.6,2.6,2.4h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastToTv);
export default __webpack_public_path__ + "static/media/castToTv.3aa98fa50d6288097c9dba3ee0c35539.svg";
export { ForwardRef as ReactComponent };